import React from 'react';
import { ScheduleMode } from '../interfaces/schedule-period.interface';
import styles from './mode-switcher.module.scss';

interface IModeSwitcherProps {
  value: ScheduleMode;
  onChange: (mode: ScheduleMode) => void;
}

const MODES: Array<{ key: ScheduleMode; label: string }> = [
  { key: 'shift', label: 'Посменный' },
  { key: 'weekly', label: 'Недельный' },
  { key: 'daily', label: 'Ежедневный' },
];

export const ModeSwitcher: React.FC<IModeSwitcherProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className={styles.mode_switcher}>
      {MODES.map((mode) => (
        <button
          key={mode.key}
          className={`${styles.mode_switcher__btn} ${
            value === mode.key ? styles.mode_switcher__btn_active : ''
          }`}
          onClick={() => onChange(mode.key)}
        >
          {mode.label}
        </button>
      ))}
    </div>
  );
};
